import equipmentService from '@/api/equipment'
import { EQUIPMENT_SET, EQUIPMENT_SET_CLIENT, CLEAR_ALL, EQUIPMENT_MOVE_RIGHT, EQUIPMENT_MOVE_LEFT, EQUIPMENT_REMOVE } from '../types'

export default {
  namespaced: true,
  state: {
    equipments: [],
    equipmentsByClient: []
  },
  getters: {
  },
  mutations: {
    [EQUIPMENT_SET] (state, equipments) {
      state.equipments = equipments
    },
    [EQUIPMENT_SET_CLIENT] (state, equipmentsByClient) {
      state.equipmentsByClient = equipmentsByClient
    },
    [CLEAR_ALL] (state) {
      state.equipments = []
      state.equipmentsByClient = []
    },
    [EQUIPMENT_MOVE_RIGHT] (state, index) {
      state.equipmentsByClient.push(state.equipments[index])
      state.equipments.splice(index, 1)
    },
    [EQUIPMENT_MOVE_LEFT] (state, index) {
      state.equipments.push(state.equipmentsByClient[index])
      state.equipmentsByClient.splice(index, 1)
    },
    [EQUIPMENT_REMOVE] (state, index) {
      state.equipments.splice(index, 1)
    }
  },
  actions: {
    getEquipmentsList: function ({commit}) {
      return new Promise((resolve, reject) => {
        equipmentService.getEquipments().then((response) => {
          commit(EQUIPMENT_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getEquipmentsListByClient: function ({ commit, state }) {
      return new Promise((resolve, reject) => {
        equipmentService.getEquipmentsByClient().then((response) => {
          if (response.data) {
            commit(EQUIPMENT_SET_CLIENT, response.data)
            if (state.equipments.length !== 0) {
              for (let i = 0; i < state.equipments.length; i++) {
                for (let j = 0; j < state.equipmentsByClient.length; j++) {
                  if (state.equipments[i].id === state.equipmentsByClient[j].id) {
                    commit(EQUIPMENT_REMOVE, i)
                    i--
                    break
                  }
                }
              }
            }
          } else {
            commit(EQUIPMENT_SET_CLIENT, [])
          }
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    clearData ({ commit }) {
      commit(CLEAR_ALL)
    },
    addEquipment ({commit}, index) {
      commit(EQUIPMENT_MOVE_RIGHT, index)
    },
    removeEquipment ({commit}, index) {
      commit(EQUIPMENT_MOVE_LEFT, index)
    },
    saveEquipmentsByClient ({state, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        let equipmentsIdList = state.equipmentsByClient.map((equipment) => equipment.id)
        equipmentService.saveEquipmentsByClient(equipmentsIdList).then(() => {
          dispatch('getEquipmentsList').then(() => {
            dispatch('getEquipmentsListByClient').then(() => {
              dispatch('Global/hideLoading', null, {root: true})
            })
          })
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    createEquipment: function ({}, equipment) {
      return new Promise((resolve, reject) => {
        equipmentService.createEquipment(equipment).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    editEquipment: function ({ dispatch }, equipment) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        equipmentService.editEquipment(equipment).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deleteEquipment: function ({ dispatch }, equipment) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        equipmentService.deleteEquipment(equipment).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    forceSync () {
      return new Promise((resolve, reject) => {
        equipmentService.forceSync().then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
  }
}
